export interface TagModel {
  key: string;
  value: string;
  label: {
    lang: string;
    value: string;
  }[];
  icon: string;
  enabled: boolean;
  metadata: {
    createdAt: string;
    updatedAt: string;
  };
}
